import SearchPage from './search-page';
export default SearchPage;